import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import 'tslib';
import '@popperjs/core';
import { LoadingIconDotted, SuccessCheckIcon, DangerIcon, TrashIcon } from '../Icon/SemanticIcons.esm.js';

var FileUploadStatus = function (_a) {
    var file = _a.file, id = _a.id, progressType = _a.progressType, errorMessage = _a.errorMessage, progress = _a.progress, _b = _a.showFileSize, showFileSize = _b === void 0 ? true : _b, onDelete = _a.onDelete;
    var name;
    var size = "0 B";
    /**
     * Following code checks if file name is bigger than 4 characters then it will replace the rest of
     * the characters with (ellipses) but it will show the file extension.
     */
    if (file.name.split(".")[0].length > 12) {
        name = [
            file.name.split(".")[0].slice(0, 7),
            "...",
            file.name.split(".")[1],
        ].join("");
    }
    else {
        name = file.name;
    }
    var handleDeleteFile = function () {
        onDelete(id);
    };
    /**
     * Following code checks the size of the file and gives it a specific unit
     */
    if (file.size < 1024) {
        size = "".concat(file.size, " B");
    }
    else if (file.size >= 1024 && file.size < Math.pow(1024, 2)) {
        var actualSize = file.size / 1024;
        actualSize < 10
            ? (size = "".concat(actualSize.toFixed(1), " KB"))
            : (size = "".concat(Math.floor(actualSize), " KB"));
    }
    else if (file.size >= Math.pow(1024, 2) && file.size < Math.pow(1024, 3)) {
        var actualSize = file.size / Math.pow(1024, 2);
        actualSize < 10
            ? (size = "".concat(actualSize.toFixed(1), " MB"))
            : (size = "".concat(Math.floor(actualSize), " MB"));
    }
    else if (file.size >= Math.pow(1024, 3)) {
        var actualSize = file.size / Math.pow(1024, 3);
        actualSize < 10
            ? (size = "".concat(actualSize.toFixed(1), " GB"))
            : (size = "".concat(Math.floor(actualSize), " GB"));
    }
    return (React.createElement("div", { className: "tw-mt-4 ".concat(progressType === "failed" ? "tw-mb-7" : "", " tw-flex tw-gap-x-8 tw-gap-y-2 tw-flex-wrap tw-justify-between tw-items-center") },
        React.createElement("div", { className: "tw-flex tw-gap-2 tw-basis-36 tw-w-full tw-h-6" },
            React.createElement("div", { className: "tw-w-8 tw-flex tw-justify-center tw-items-center" },
                progressType === "pending" && (React.createElement(LoadingIconDotted, { addClassName: classNames("tw-opacity-60 tw-animate-spin"), size: "lg" })),
                progressType === "fulfilled" && (React.createElement(SuccessCheckIcon, { addClassName: classNames("tw-opacity-100 tw-text-risk-2"), size: "lg" })),
                progressType === "failed" && (React.createElement(DangerIcon, { addClassName: classNames("tw-opacity-100 tw-text-risk-critical"), size: "lg" }))),
            React.createElement("div", { className: "tw-flex tw-gap-4 tw-justify-evenly tw-w-full" },
                React.createElement("span", { role: "name", className: "tw-font-normal tw-leading-6 tw-text-xs tw-text-gray-900 tw-font-lato tw-p-0 tw-m-0 tw-whitespace-nowrap tw-max-w-min" }, name),
                showFileSize && (React.createElement("span", { role: "size", className: "tw-font-normal tw-text-xs tw-leading-6 tw-text-gray-600 tw-font-lato tw-p-0 tw-m-0 tw-whitespace-nowrap tw-max-w-min" }, size)))),
        React.createElement("div", { className: "tw-flex tw-items-start tw-relative tw-gap-y-2 tw-grow tw-basis-52" },
            React.createElement("div", { className: "tw-flex tw-w-full tw-items-center tw-gap-8" },
                React.createElement("div", { className: "tw-grow tw-h-2 tw-bg-gray-300 tw-rounded-3xl tw-relative" },
                    React.createElement("div", { className: "tw-h-full ".concat(progressType === "failed"
                            ? "tw-bg-risk-critical"
                            : "tw-bg-risk-pass", " tw-rounded-3xl tw-top-0 tw-left-0 tw-ease-in-out tw-transition-width tw-duration-700"), style: { width: "".concat(progress, "%") }, role: "progressbar" })),
                React.createElement(TrashIcon, { addClassName: classNames("tw-opacity-60 tw-cursor-pointer"), size: "md", onClick: handleDeleteFile })),
            progressType === "failed" && (React.createElement("span", { role: "err-msg", className: "tw-absolute tw-top-4 tw-font-normal tw-text-xs tw-text-risk-critical tw-font-lato tw-p-0 tw-m-0" }, errorMessage)))));
};

export { FileUploadStatus };
//# sourceMappingURL=FileUploadStatus.esm.js.map
